import React from 'react'
import { MaskField } from "react-mask-field";
export default function CnicInput({ value, onChange,placeholder,readOnly=false }) {
    return (
        <>
            <MaskField
                className="form-control"
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                mask="_____-_______-_"
                showMask
                replacement={{ _: /\d/ }}
                readOnly={readOnly}
            />
        </>
    )
}
